import React from 'react'
import { ToastContainer } from 'react-toastify'
import Pricing from './components/Pricing'

import './styles/pricing.css'
import './styles/cpop-pricing.css'
import './styles/crumplepop/creator-host-modal.css'
import CpopPricing from './components/crumplepop/CpopPricing'

import { useTranslation } from 'react-i18next'

type Props = {
    product: string
}

export default function App({ product }: Props) {
    const {t} = useTranslation('checkout');

    let content = <></>
    if (product.toLowerCase() == 'crumplepop') {
        content = <Pricing defaultProduct={product} />
    }
    else{
        content = <Pricing defaultProduct={product} />
    }

    return (
        <div>
            <h2 className='pricing-tool-title'>{t('purchase.plans')}</h2>
            {content}
            <ToastContainer />
        </div>
    )
}
